import React from 'react';
import {
  View,
  Header,
  Title,
  BodyText,
  SecondaryText,
  CommentText,
  NumericalValue,
  Button,
} from 'app/modules/styled';
import { StyledTextarea, Input } from 'app/modules/styled/web';

export default () => (
  <View sx={{ p: 4 }}>
    <Header sx={{ mt: 2 }}>Header</Header>
    <Title sx={{ mt: 2 }}>Title</Title>
    <BodyText sx={{ mt: 2 }}>BodyText</BodyText>
    <SecondaryText sx={{ mt: 2 }}>SecondaryText</SecondaryText>
    <NumericalValue sx={{ mt: 2 }}>NumericalValue</NumericalValue>
    <Button sx={{ mt: 2, mr: 'auto' }}>Button</Button>
    <Button disabled sx={{ mt: 2, mr: 'auto' }}>
      Disabled Button
    </Button>
    <Input type={'text'} value={'Input'} sx={{ mr: 'auto', mt: 2 }} />
    <CommentText sx={{ mt: 2, mr: 'auto' }}>CommentText</CommentText>
    <StyledTextarea value={'StyledTextarea'} mt={2} />
  </View>
);
